(function () {
  const MOBILE_BREAKPOINT = 999;
  const DEFAULT_CENTER = { latitude: 46.603354, longitude: 1.888334 };
  const CITY_FOCUS_ZOOM = 13.5;
  const SHEET_SPRING_STIFFNESS = 240;
  const SHEET_SPRING_DAMPING = 28;
  const SHEET_FLICK_DECELERATION = 0.99;
  // Peau « galerie » (refonte, depot-vente-galerie.css) : repères numérotés,
  // invitation une fois par visite, passage d'adresse du hub vers la carte.
  const INVITATION_KEY = 'jaiio-dv-invitation';
  const ORIGIN_KEY = 'jaiio-dv-origine';
  // La carte plein écran range la liste dans une feuille basse sur téléphone ;
  // ailleurs la liste reste dans le flux (comportement historique).
  let sheetEnabled = false;

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-depot-vente-root]').forEach(initDepotVente);
    document.querySelectorAll('[data-depot-vente-preview]').forEach(initPreview);
  });

  function initDepotVente(root) {
    const configNode = root.querySelector('[data-depot-vente-config]');
    const mapNode = root.querySelector('[data-map]');

    if (!configNode || !mapNode) return;

    let config;
    try {
      config = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      console.error('Depot-vente config parse error', error);
      return;
    }

    const state = {
      root: root,
      config: config,
      mapOnly: root.dataset.mapOnly === 'true' || root.classList.contains('depot-vente-map-page'),
      galerie: root.dataset.skin === 'galerie',
      map: null,
      mapReady: false,
      lazyMap: Boolean(config.lazyMap),
      boundaryLayer: null,
      boundaryRequestId: 0,
      boundaryHandle: '',
      markerLayer: null,
      userMarker: null,
      markers: new Map(),
      activeShopHandle: null,
      currentCityFilter: config.currentCityHandle || 'all',
      currentCoords: null,
      currentAddressLabel: '',
      pendingDirectionsUrl: '',
      visibleShops: config.shops.slice(),
      collapsed: window.innerWidth <= MOBILE_BREAKPOINT,
      listPage: 1,
      listPageSize: getListPageSize(config),
      sheetTranslate: 0,
      sheetVelocity: 0,
      sheetAnimationId: 0,
      sheetDrag: null,
      sheetElements: {},
      pendingMapResize: 0,
      addressSuggestions: [],
      addressSuggestionItems: [],
      activeSuggestionIndex: -1,
      suggestionTimer: 0,
      suggestionAbortController: null,
      localitySuggestions: buildLocalitySuggestions(config),
    };

    if (state.mapOnly && !state.galerie) {
      document.documentElement.classList.add('depot-vente-map-page-active');
      document.body.classList.add('depot-vente-map-page-active');
    }

    if (state.mapOnly && state.galerie) {
      sheetEnabled = true;
    }

    setupBottomSheet(state);
    bindMapFacade(state);
    if (!state.lazyMap) {
      initMap(state);
    }
    bindMapTouchLock(state);
    bindFilterButtons(state);
    bindListButtons(state);
    bindPopupButtons(state);
    bindPagination(state);
    bindSearch(state);
    bindModal(state);

    updateVisibleShops(state, {
      resetPage: true,
      fitMap: config.mode === 'hub',
    });

    if (state.galerie && state.mapOnly) {
      // Après le chargement complet : la carte a alors sa taille définitive,
      // sinon le recentrage sur l'adresse ou le dépôt tombe à côté.
      const restore = function () {
        if (state.map) state.map.invalidateSize();
        restoreHandoff(state);
      };
      if (document.readyState === 'complete') {
        restore();
      } else {
        window.addEventListener('load', restore, { once: true });
      }
    }
  }

  // Carte plein écran : reprend l'adresse saisie sur le hub (sessionStorage,
  // jamais dans l'URL) et le dépôt demandé depuis la landing (#handle).
  function restoreHandoff(state) {
    const input = state.root.querySelector('[data-address-input]');
    const status = state.root.querySelector('[data-search-status]');
    let origin = null;

    try {
      origin = JSON.parse(window.sessionStorage.getItem(ORIGIN_KEY) || 'null');
      window.sessionStorage.removeItem(ORIGIN_KEY);
    } catch (error) {
      origin = null;
    }

    if (origin && Number.isFinite(Number(origin.latitude)) && Number.isFinite(Number(origin.longitude))) {
      if (input) input.value = origin.label || '';
      applyOrigin(state, { latitude: Number(origin.latitude), longitude: Number(origin.longitude) }, origin.label || 'votre adresse', status);
      return;
    }

    // La landing lie « #<handle> » ; les ancres de la liste sont « #shop-<handle> ».
    const raw = decodeURIComponent(window.location.hash.slice(1));
    const handle = findShop(state, raw) ? raw : raw.replace(/^shop-/, '');
    if (handle && findShop(state, handle)) {
      activateShop(state, handle, true, 'hash');
    }
  }

  function setupBottomSheet(state) {
    const pane = state.root.querySelector('[data-list-pane]');
    const handle = state.root.querySelector('.depot-vente__sheet-handle');
    const toggles = state.root.querySelectorAll('[data-sheet-toggle], [data-mobile-sheet-toggle]');

    state.sheetElements = {
      pane: pane,
      handle: handle,
      toggles: toggles,
    };

    if (!pane) return;

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (!isMobileViewport() || usesInlineMobileList()) return;
        state.collapsed = !state.collapsed;
        animateSheetTo(state, state.collapsed ? getSheetMaxTranslate(state) : 0, 0);
        updateSheetUI(state);
      });
    });

    if (handle) {
      handle.addEventListener('pointerdown', function (event) {
        if (!isMobileViewport() || usesInlineMobileList()) return;
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        startSheetDrag(state, handle, event);
      });
    }

    window.addEventListener('resize', function () {
      const previousMobileViewport = state.sheetElements.pane.dataset.mobileViewport === 'true';
      const pageSizeChanged = state.listPageSize !== getListPageSize(state.config);
      state.listPageSize = getListPageSize(state.config);
      clampListPage(state);

      if (!isMobileViewport()) {
        state.collapsed = false;
        stopSheetAnimation(state);
        clearSheetTransform(state);
      } else if (!previousMobileViewport || pageSizeChanged) {
        state.collapsed = usesInlineMobileList() ? false : true;
      }

      updateSheetUI(state);
      renderList(state);
      updatePagination(state);
      renderMarkers(state);
      fitMapToCurrentScope(state);
      scheduleMapResize(state);
    });

    updateSheetUI(state);
  }

  function startSheetDrag(state, dragSource, event) {
    const pane = state.sheetElements.pane;
    if (!pane) return;

    stopSheetAnimation(state);
    state.sheetDrag = {
      pointerId: event.pointerId,
      startY: event.clientY,
      startTranslate: getCurrentSheetTranslate(state),
      history: [{ time: Date.now(), y: event.clientY }],
    };

    event.preventDefault();
    dragSource.setPointerCapture(event.pointerId);
    pane.classList.add('is-dragging');

    const move = function (moveEvent) {
      if (!state.sheetDrag || moveEvent.pointerId !== state.sheetDrag.pointerId) return;

      const maxTranslate = getSheetMaxTranslate(state);
      const delta = moveEvent.clientY - state.sheetDrag.startY;
      let nextTranslate = state.sheetDrag.startTranslate + delta;

      if (nextTranslate < 0) {
        nextTranslate = -rubberband(Math.abs(nextTranslate), window.innerHeight);
      } else if (nextTranslate > maxTranslate) {
        nextTranslate = maxTranslate + rubberband(nextTranslate - maxTranslate, window.innerHeight);
      }

      applySheetTranslate(state, nextTranslate);
      pushDragHistory(state.sheetDrag.history, moveEvent.clientY);
      moveEvent.preventDefault();
    };

    const finish = function (finishEvent) {
      if (!state.sheetDrag || finishEvent.pointerId !== state.sheetDrag.pointerId) return;

      const velocity = computeDragVelocity(state.sheetDrag.history);
      const maxTranslate = getSheetMaxTranslate(state);
      const projected = clamp(
        getCurrentSheetTranslate(state) + project(velocity, SHEET_FLICK_DECELERATION),
        0,
        maxTranslate
      );
      const target = projected > maxTranslate / 2 ? maxTranslate : 0;

      state.collapsed = target !== 0;
      state.sheetDrag = null;
      pane.classList.remove('is-dragging');
      dragSource.releasePointerCapture(finishEvent.pointerId);

      animateSheetTo(state, target, velocity);
      updateSheetUI(state);
    };

    dragSource.addEventListener('pointermove', move);
    dragSource.addEventListener('pointerup', finish, { once: true });
    dragSource.addEventListener('pointercancel', finish, { once: true });

    const cleanup = function () {
      dragSource.removeEventListener('pointermove', move);
      pane.classList.remove('is-dragging');
    };

    dragSource.addEventListener('pointerup', cleanup, { once: true });
    dragSource.addEventListener('pointercancel', cleanup, { once: true });
  }

  function animateSheetTo(state, target, initialVelocity) {
    if (!isMobileViewport() || usesInlineMobileList()) {
      clearSheetTransform(state);
      return;
    }

    const pane = state.sheetElements.pane;
    if (!pane) return;

    stopSheetAnimation(state);
    state.sheetVelocity = Number.isFinite(initialVelocity) ? initialVelocity : 0;

    if (prefersReducedMotion()) {
      applySheetTranslate(state, target);
      state.collapsed = target !== 0;
      updateSheetUI(state);
      scheduleMapResize(state);
      return;
    }

    let lastTime = 0;

    const step = function (timestamp) {
      if (!lastTime) {
        lastTime = timestamp;
      }

      const dt = Math.min(0.032, (timestamp - lastTime) / 1000);
      lastTime = timestamp;

      const displacement = target - state.sheetTranslate;
      const acceleration = displacement * SHEET_SPRING_STIFFNESS - state.sheetVelocity * SHEET_SPRING_DAMPING;

      state.sheetVelocity += acceleration * dt;
      state.sheetTranslate += state.sheetVelocity * dt;

      applySheetTranslate(state, state.sheetTranslate);

      if (Math.abs(displacement) < 0.5 && Math.abs(state.sheetVelocity) < 8) {
        applySheetTranslate(state, target);
        state.collapsed = target !== 0;
        updateSheetUI(state);
        scheduleMapResize(state);
        state.sheetAnimationId = 0;
        return;
      }

      state.sheetAnimationId = window.requestAnimationFrame(step);
    };

    state.sheetAnimationId = window.requestAnimationFrame(step);
  }

  function stopSheetAnimation(state) {
    if (state.sheetAnimationId) {
      window.cancelAnimationFrame(state.sheetAnimationId);
      state.sheetAnimationId = 0;
    }
  }

  function updateSheetUI(state) {
    const pane = state.sheetElements.pane;
    if (!pane) return;

    const mobile = isMobileViewport();
    pane.dataset.mobileViewport = mobile ? 'true' : 'false';
    pane.dataset.sheetCollapsed = mobile && state.collapsed && !usesInlineMobileList() ? 'true' : 'false';

    if (mobile && usesInlineMobileList()) {
      state.collapsed = false;
      clearSheetTransform(state);
      return;
    }

    if (!mobile) {
      clearSheetTransform(state);
    } else if (!state.sheetDrag && !state.sheetAnimationId) {
      applySheetTranslate(state, state.collapsed ? getSheetMaxTranslate(state) : 0);
    }

    state.sheetElements.toggles.forEach(function (toggle) {
      if (toggle.hasAttribute('data-mobile-sheet-toggle')) {
        toggle.textContent = state.collapsed ? 'Liste' : 'Carte';
      } else {
        toggle.textContent = state.collapsed ? 'Voir la liste' : 'Voir la carte';
      }
    });
  }

  function clearSheetTransform(state) {
    const pane = state.sheetElements.pane;
    if (!pane) return;

    pane.style.transform = '';
    state.sheetTranslate = 0;
  }

  function getCurrentSheetTranslate(state) {
    if (!isMobileViewport() || usesInlineMobileList()) return 0;

    if (Number.isFinite(state.sheetTranslate)) {
      return state.sheetTranslate;
    }

    return state.collapsed ? getSheetMaxTranslate(state) : 0;
  }

  function applySheetTranslate(state, translate) {
    const pane = state.sheetElements.pane;
    if (!pane || !isMobileViewport() || usesInlineMobileList()) return;

    const safeTranslate = clamp(translate, -96, getSheetMaxTranslate(state) + 96);
    pane.style.transform = 'translateY(' + safeTranslate + 'px)';
    state.sheetTranslate = safeTranslate;
  }

  function getSheetMaxTranslate(state) {
    const pane = state.sheetElements.pane;
    if (!pane || usesInlineMobileList()) return 0;

    const peekHeight = window.innerWidth <= 479
      ? Math.min(282, window.innerHeight * 0.46)
      : Math.min(336, window.innerHeight * 0.42);

    return Math.max(0, pane.offsetHeight - peekHeight);
  }

  function initMap(state) {
    if (state.mapReady) return true;

    if (!window.L) {
      console.warn('Leaflet non disponible');
      return false;
    }

    const currentCity = getCityByHandle(state, state.config.currentCityHandle);
    const initialLat = currentCity ? Number(currentCity.latitude) : DEFAULT_CENTER.latitude;
    const initialLng = currentCity ? Number(currentCity.longitude) : DEFAULT_CENTER.longitude;
    const initialZoom = currentCity ? CITY_FOCUS_ZOOM : 6;

    state.map = window.L.map(state.root.querySelector('[data-map]'), {
      zoomControl: true,
      scrollWheelZoom: true,
      preferCanvas: state.mapOnly && isMobileViewport(),
      zoomSnap: 0.25,
      zoomDelta: 0.5,
      wheelPxPerZoomLevel: 140,
      wheelDebounceTime: state.mapOnly && isMobileViewport() ? 80 : 40,
      tap: false,
      touchZoom: true,
      doubleClickZoom: true,
      dragging: true,
      fadeAnimation: !isMobileViewport(),
      inertia: !isMobileViewport(),
      markerZoomAnimation: !isMobileViewport(),
      zoomAnimation: !isMobileViewport(),
    }).setView([initialLat, initialLng], initialZoom);

    addBaseLayer(state.map, { keepBuffer: isMobileViewport() ? 2 : 3 });

    if (state.galerie) {
      state.map.zoomControl.setPosition('bottomright');

      // La feuille de style de la section arrive dans le corps de la page :
      // la carte peut être créée avant d'avoir sa taille finale.
      if ('ResizeObserver' in window) {
        new ResizeObserver(function () {
          scheduleMapResize(state);
        }).observe(state.root.querySelector('[data-map]'));
      }
      window.addEventListener('load', function () {
        state.map.invalidateSize();
        if (!state.currentCoords && !state.activeShopHandle) fitMapToCurrentScope(state);
      }, { once: true });
      if (state.config.mode === 'hub') {
        state.map.scrollWheelZoom.disable();
      }
    }

    state.markerLayer = window.L.layerGroup().addTo(state.map);
    state.mapReady = true;
    syncMapState(state, true);
    scheduleMapResize(state);
    return true;
  }

  // Fond Plan IGN (Géoplateforme, sans clé, Licence Ouverte) : les tuiles CARTO
  // exigent une clé depuis octobre 2026 et affichaient « API KEY REQUIRED ».
  function addBaseLayer(map, options) {
    return window.L.tileLayer('https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0&LAYER=GEOGRAPHICALGRIDSYSTEMS.PLANIGNV2&STYLE=normal&TILEMATRIXSET=PM&FORMAT=image/png&TILEMATRIX={z}&TILEROW={y}&TILECOL={x}', Object.assign({
      attribution: '&copy; <a href="https://www.ign.fr/" rel="noopener" target="_blank">IGN</a> – Plan IGN',
      className: 'depot-vente-tiles',
      maxZoom: 19,
      updateWhenIdle: true,
    }, options || {})).addTo(map);
  }

  // Aperçu de la landing ville : carte figée (aucune interaction, tout clic va
  // au lien qui l'entoure), repères numérotés comme la liste.
  function initPreview(node) {
    const configNode = node.querySelector('[data-depot-vente-config]');
    const mapNode = node.querySelector('[data-map]');
    if (!configNode || !mapNode) return;

    let config;
    try {
      config = JSON.parse(configNode.textContent || '{}');
    } catch (error) {
      return;
    }

    const shops = (config.shops || []).filter(hasCoordinates);

    function draw() {
      if (!window.L) return;

      const map = window.L.map(mapNode, {
        zoomControl: false,
        attributionControl: false,
        dragging: false,
        touchZoom: false,
        doubleClickZoom: false,
        scrollWheelZoom: false,
        boxZoom: false,
        keyboard: false,
        tap: false,
        zoomSnap: 0.25,
        fadeAnimation: false,
      });
      addBaseLayer(map);

      const city = (config.cities || [])[0];
      if (shops.length) {
        const bounds = window.L.latLngBounds(shops.map(function (shop) {
          return [Number(shop.latitude), Number(shop.longitude)];
        }));
        // Le bloc blanc couvre le coin bas gauche (ordinateur) ou tout le bas
        // (téléphone) de l'aperçu : les repères restent dans la partie libre.
        const wide = window.innerWidth >= 741;
        map.fitBounds(bounds, {
          paddingTopLeft: [wide ? 540 : 40, 64],
          paddingBottomRight: [40, wide ? 48 : 290],
          maxZoom: 15,
        });
      } else if (city && hasCoordinates(city)) {
        map.setView([Number(city.latitude), Number(city.longitude)], 12);
      }

      shops.forEach(function (shop, index) {
        window.L.marker([Number(shop.latitude), Number(shop.longitude)], {
          icon: numberedIcon(index + 1, false),
          interactive: false,
          keyboard: false,
        }).addTo(map);
      });
    }

    // Leaflet est chargé en différé et la carte n'est utile qu'une fois visible.
    function whenReady() {
      if (window.L) {
        draw();
      } else {
        window.addEventListener('load', draw, { once: true });
      }
    }

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          observer.disconnect();
          whenReady();
        }
      }, { rootMargin: '200px' });
      observer.observe(node);
    } else {
      whenReady();
    }
  }

  function numberedIcon(label, isActive, extraClass) {
    const size = isActive ? 36 : (extraClass ? 34 : 30);
    return window.L.divIcon({
      className: '',
      html: '<span class="dv-pin' + (isActive ? ' is-active' : '') + (extraClass ? ' ' + extraClass : '') + '">' + escapeHtml(String(label)) + '</span>',
      iconSize: [size, size],
      iconAnchor: [size / 2, size / 2],
    });
  }

  function bindMapFacade(state) {
    const activateButton = state.root.querySelector('[data-map-activate]');
    if (!activateButton) return;

    activateButton.addEventListener('click', function () {
      ensureMapReady(state, true);
    });
  }

  function ensureMapReady(state, shouldFit) {
    const wasReady = state.mapReady;
    if (!initMap(state)) return false;
    if (wasReady) {
      syncMapState(state, shouldFit !== false);
    }
    return true;
  }

  function bindMapTouchLock(state) {
    if (!state.mapOnly) return;

    const mapNode = state.root.querySelector('[data-map]');
    if (!mapNode) return;

    const interactiveSelector = 'a, button, input, textarea, select, label, [role="button"]';
    let activeTouches = 0;

    function shouldLockTouch(event) {
      return isMobileViewport() && !(event.target && event.target.closest(interactiveSelector));
    }

    function enableTouchLock() {
      document.documentElement.classList.add('depot-vente-map-lock');
      document.body.classList.add('depot-vente-map-lock');
    }

    function disableTouchLock() {
      document.documentElement.classList.remove('depot-vente-map-lock');
      document.body.classList.remove('depot-vente-map-lock');
    }

    mapNode.addEventListener('touchstart', function (event) {
      if (!shouldLockTouch(event)) return;
      activeTouches += 1;
      enableTouchLock();
    }, { passive: true });

    mapNode.addEventListener('touchmove', function (event) {
      if (!shouldLockTouch(event)) return;
      event.preventDefault();
    }, { passive: false });

    function endTouchLock() {
      activeTouches = Math.max(0, activeTouches - 1);
      if (activeTouches === 0) {
        disableTouchLock();
      }
    }

    mapNode.addEventListener('touchend', endTouchLock, { passive: true });
    mapNode.addEventListener('touchcancel', function () {
      activeTouches = 0;
      disableTouchLock();
    }, { passive: true });
  }

  function syncMapState(state, shouldFit) {
    const facade = state.root.querySelector('[data-map-facade]');
    const scopedCityHandle = state.currentCityFilter !== 'all'
      ? state.currentCityFilter
      : state.config.currentCityHandle;

    if (facade) {
      facade.hidden = true;
    }

    if (scopedCityHandle) {
      updateBoundary(state, scopedCityHandle, { fit: shouldFit });
    } else if (shouldFit) {
      fitMapToCurrentScope(state);
    }

    renderMarkers(state);
    scheduleMapResize(state);
  }

  function bindFilterButtons(state) {
    state.root.querySelectorAll('[data-city-filter]').forEach(function (button) {
      button.addEventListener('click', function () {
        state.currentCityFilter = button.dataset.cityFilter || 'all';
        state.activeShopHandle = null;

        state.root.querySelectorAll('[data-city-filter]').forEach(function (item) {
          item.classList.toggle('is-active', item === button);
        });

        updateBoundary(state, state.currentCityFilter === 'all' ? '' : state.currentCityFilter, { fit: true });
        updateVisibleShops(state, {
          resetPage: true,
          fitMap: state.currentCityFilter === 'all',
        });
      });
    });
  }

  function bindListButtons(state) {
    const list = state.root.querySelector('[data-shop-list]');
    if (!list) return;

    list.addEventListener('click', function (event) {
      const card = event.target.closest('[data-shop-card]');
      if (!card) return;

      const handle = card.dataset.shopHandle || '';
      if (!handle) return;

      if (event.target.closest('[data-itinerary]')) {
        event.preventDefault();
        const shop = findShop(state, handle);
        if (!shop) return;

        activateShop(state, handle, false, 'list');
        openDirections(state, shop);
        return;
      }

      if (event.target.closest('[data-map-focus]')) {
        event.preventDefault();
        activateShop(state, handle, true, 'list');
        return;
      }

      if (event.target.closest('a, button')) return;
      activateShop(state, handle, true, 'list');
    });
  }

  function bindPagination(state) {
    const pagination = state.root.querySelector('[data-pagination]');
    if (!pagination) return;

    const previousButton = pagination.querySelector('[data-pagination-prev]');
    const nextButton = pagination.querySelector('[data-pagination-next]');

    if (previousButton) {
      previousButton.addEventListener('click', function () {
        state.listPage = Math.max(1, state.listPage - 1);
        renderList(state);
        updatePagination(state);
        scrollListToTop(state);
      });
    }

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        state.listPage = Math.min(getPageCount(state), state.listPage + 1);
        renderList(state);
        updatePagination(state);
        scrollListToTop(state);
      });
    }
  }

  function bindPopupButtons(state) {
    state.root.addEventListener('click', function (event) {
      const trigger = event.target.closest('[data-popup-itinerary]');
      if (!trigger) return;

      event.preventDefault();

      const handle = trigger.getAttribute('data-popup-itinerary') || '';
      if (!handle) return;

      const shop = findShop(state, handle);
      if (!shop) return;

      activateShop(state, handle, false, 'popup');
      openDirections(state, shop);
    });
  }

  function bindSearch(state) {
    const form = state.root.querySelector('[data-address-form]');
    const input = state.root.querySelector('[data-address-input]');
    const dropdown = state.root.querySelector('[data-address-dropdown]');
    const suggestions = state.root.querySelector('[data-address-suggestions]');
    const geoButton = state.root.querySelector('[data-geolocate]');
    const status = state.root.querySelector('[data-search-status]');

    if (!form || !input) return;

    input.setAttribute('aria-autocomplete', 'list');

    function clearSuggestionRequest() {
      if (state.suggestionTimer) {
        window.clearTimeout(state.suggestionTimer);
        state.suggestionTimer = 0;
      }

      if (state.suggestionAbortController) {
        state.suggestionAbortController.abort();
        state.suggestionAbortController = null;
      }
    }

    function renderSuggestions(query) {
      updateAddressSuggestions(state, {
        dropdown: dropdown,
        list: suggestions,
      }, query, input, status);
    }

    input.addEventListener('input', function () {
      const sanitizedValue = sanitizeAddressInput(input.value);
      if (sanitizedValue !== input.value) {
        input.value = sanitizedValue;
      }

      const query = sanitizedValue.trim();

      clearSuggestionRequest();

      if (query.length < 2) {
        state.addressSuggestions = [];
        state.addressSuggestionItems = [];
        state.activeSuggestionIndex = -1;
        renderSuggestions(query);
        return;
      }

      state.suggestionTimer = window.setTimeout(function () {
        state.suggestionAbortController = new AbortController();
        fetchAddressSuggestions(query, getSuggestionContext(state), state.suggestionAbortController.signal)
          .then(function (results) {
            state.addressSuggestions = results;
            state.activeSuggestionIndex = results.length ? 0 : -1;
            renderSuggestions(query);
          })
          .catch(function (error) {
            if (error && error.name === 'AbortError') return;
            state.addressSuggestions = [];
            state.addressSuggestionItems = [];
            state.activeSuggestionIndex = -1;
            renderSuggestions(query);
          })
          .finally(function () {
            state.suggestionAbortController = null;
          });
      }, 120);
    });

    input.addEventListener('focus', function () {
      const sanitizedValue = sanitizeAddressInput(input.value);
      if (sanitizedValue !== input.value) {
        input.value = sanitizedValue;
      }

      const query = sanitizedValue.trim();
      if (query.length >= 2 && (state.addressSuggestions.length || state.addressSuggestionItems.length)) {
        renderSuggestions(query);
      }
    });

    input.addEventListener('keydown', function (event) {
      const items = state.addressSuggestionItems || [];
      if (!items.length) {
        if (event.key === 'Escape') {
          state.activeSuggestionIndex = -1;
          renderSuggestions('');
        }

        return;
      }

      if (event.key === 'ArrowDown') {
        event.preventDefault();
        state.activeSuggestionIndex = (state.activeSuggestionIndex + 1 + items.length) % items.length;
        syncAddressSuggestionActiveState(suggestions, state.activeSuggestionIndex);
        return;
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault();
        state.activeSuggestionIndex = (state.activeSuggestionIndex - 1 + items.length) % items.length;
        syncAddressSuggestionActiveState(suggestions, state.activeSuggestionIndex);
        return;
      }

      if (event.key === 'Enter' && state.activeSuggestionIndex >= 0) {
        event.preventDefault();
        applyAddressSuggestionSelection(state, items[state.activeSuggestionIndex], input, status, {
          dropdown: dropdown,
          list: suggestions,
        });
        return;
      }

      if (event.key === 'Escape') {
        state.activeSuggestionIndex = -1;
        renderSuggestions('');
      }
    });

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      performAddressSearch(state, input, status, {
        dropdown: dropdown,
        list: suggestions,
      });
    });

    if (geoButton) {
      geoButton.addEventListener('click', function () {
        clearSuggestionRequest();
        state.addressSuggestions = [];
        state.addressSuggestionItems = [];
        state.activeSuggestionIndex = -1;
        renderSuggestions('');

        if (!navigator.geolocation) {
          setStatus(status, 'La géolocalisation n’est pas disponible sur cet appareil.');
          return;
        }

        setStatus(status, 'Recherche de votre position...');
        navigator.geolocation.getCurrentPosition(
          function (position) {
            applyOrigin(state, {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            }, 'votre position', status);
          },
          function () {
            setStatus(status, 'Impossible d’accéder à votre position.');
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
          }
        );
      });
    }

    document.addEventListener('pointerdown', function (event) {
      if (form.contains(event.target) || (dropdown && dropdown.contains(event.target))) return;
      state.activeSuggestionIndex = -1;
      renderSuggestions('');
    });
  }

  function cancelSuggestionLookup(state) {
    if (state.suggestionTimer) {
      window.clearTimeout(state.suggestionTimer);
      state.suggestionTimer = 0;
    }

    if (state.suggestionAbortController) {
      state.suggestionAbortController.abort();
      state.suggestionAbortController = null;
    }
  }

  function bindModal(state) {
    const modal = state.root.querySelector('[data-itinerary-modal]');
    if (!modal) return;

    modal.querySelectorAll('[data-modal-close]').forEach(function (node) {
      node.addEventListener('click', function () {
        closeModal(modal);
      });
    });

    const secondary = modal.querySelector('[data-modal-secondary]');
    if (secondary) {
      secondary.addEventListener('click', function () {
        closeModal(modal);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) closeModal(modal);
    });
  }

  function updateVisibleShops(state, options) {
    const settings = options || {};
    const filtered = state.config.shops.filter(function (shop) {
      return state.currentCityFilter === 'all' || shop.cityHandle === state.currentCityFilter;
    });

    state.visibleShops = filtered.slice();

    if (state.currentCoords) {
      state.visibleShops.sort(function (left, right) {
        return computeDistance(state.currentCoords, left) - computeDistance(state.currentCoords, right);
      });
    }

    if (settings.resetPage) {
      state.listPage = 1;
    }

    clampListPage(state);
    ensureActiveShop(state);

    renderList(state);
    renderMarkers(state);
    updateCounts(state);
    updatePagination(state);

    if (settings.fitMap !== false) {
      fitMapToCurrentScope(state);
    }
  }

  function ensureActiveShop(state) {
    const activeStillVisible = state.visibleShops.some(function (shop) {
      return shop.handle === state.activeShopHandle;
    });

    if (!activeStillVisible) {
      state.activeShopHandle = null;
    }

    if (isPaginatedList(state) && state.activeShopHandle) {
      syncListPageForShop(state, state.activeShopHandle);
    }
  }

  function renderList(state) {
    const list = state.root.querySelector('[data-shop-list]');
    if (!list) return;

    const listShops = getListShops(state);
    const orderedHandles = listShops.map(function (shop) {
      return shop.handle;
    });

    if (state.config.mode === 'hub') {
      list.innerHTML = listShops
        .map(function (shop, index) {
          return buildShopCardMarkup(state, shop, getListStartIndex(state) + index + 1);
        })
        .join('');
      return;
    }

    orderedHandles.forEach(function (handle, index) {
      const card = list.querySelector('[data-shop-handle="' + cssEscape(handle) + '"]');
      const shop = findShop(state, handle);
      if (!card || !shop) return;

      list.appendChild(card);

      const indexNode = card.querySelector('.depot-vente-shop-card__index, [data-shop-index]');
      if (indexNode) {
        indexNode.textContent = String(getListStartIndex(state) + index + 1);
      }

      const distanceNode = card.querySelector('[data-distance]');
      if (distanceNode && state.currentCoords) {
        distanceNode.hidden = false;
        distanceNode.textContent = formatDistance(computeDistance(state.currentCoords, shop));
      } else if (distanceNode) {
        distanceNode.hidden = true;
        distanceNode.textContent = '';
      }
    });

    state.root.querySelectorAll('[data-shop-card]').forEach(function (card) {
      const handle = card.dataset.shopHandle || '';
      const visible = orderedHandles.indexOf(handle) !== -1;
      card.hidden = !visible;
      card.classList.toggle('is-active', visible && handle === state.activeShopHandle);
    });
  }

  function renderMarkers(state) {
    if (!state.map || !state.markerLayer || !window.L) return;

    state.markerLayer.clearLayers();
    state.markers.clear();

    if (state.galerie && state.config.mode === 'hub') {
      renderCityMarkers(state);
      return;
    }

    getMappableShops(state).forEach(function (shop, index) {
      const isActive = shop.handle === state.activeShopHandle;
      const icon = state.galerie ? numberedIcon(index + 1, isActive) : window.L.divIcon({
        className: '',
        html:
          '<div class="depot-vente-marker' +
          (isActive ? ' is-active' : '') +
          '"><span aria-hidden="true"></span></div>',
        iconSize: [22, 22],
        iconAnchor: [11, 11],
      });

      const marker = window.L.marker([Number(shop.latitude), Number(shop.longitude)], {
        icon: icon,
        keyboard: true,
      });

      if (state.mapOnly || !isMobileViewport()) {
        marker.bindPopup(buildPopupMarkup(state, shop), {
          closeButton: false,
          autoClose: state.mapOnly,
          closeOnClick: state.mapOnly,
          className: state.galerie ? 'dv-popup' : 'depot-vente-popup-shell',
          offset: [0, state.galerie ? -16 : -22],
        });
      }

      marker.on('click', function () {
        activateShop(state, shop.handle, true, 'marker');

        if (state.mapOnly && marker.getPopup()) {
          marker.openPopup();
        }
      });

      marker.addTo(state.markerLayer);

      if (isActive && (state.mapOnly || !isMobileViewport()) && marker.getPopup()) {
        marker.openPopup();
      }

      state.markers.set(shop.handle, marker);
    });
  }

  // Hub : les douze premières villes (ordre de la liste) portent leur nombre de
  // dépôts, les autres un simple point ; chaque repère mène à la page ville.
  function renderCityMarkers(state) {
    (state.config.cities || []).filter(hasCoordinates).forEach(function (city, index) {
      const featured = index < 12;
      const marker = window.L.marker([Number(city.latitude), Number(city.longitude)], {
        icon: featured
          ? numberedIcon(city.shopCount || '', false, 'dv-pin--city')
          : window.L.divIcon({ className: '', html: '<span class="dv-dot"></span>', iconSize: [10, 10], iconAnchor: [5, 5] }),
        keyboard: true,
        // Les villes les plus fournies passent devant leurs voisines (Paris et sa couronne).
        zIndexOffset: featured ? 1000 + (Number(city.shopCount) || 0) * 10 : 0,
        title: city.name + ' · ' + city.shopCount + (city.shopCount > 1 ? ' dépôts' : ' dépôt'),
      });
      marker.on('click', function () {
        if (city.url) window.location.href = city.url;
      });
      marker.addTo(state.markerLayer);
    });
  }

  function activateShop(state, handle, panTo, source) {
    const shop = findShop(state, handle);
    if (!shop) return;

    state.activeShopHandle = handle;

    if (isPaginatedList(state)) {
      syncListPageForShop(state, handle);
    }

    renderList(state);
    renderMarkers(state);
    updatePagination(state);

    if (panTo && hasCoordinates(shop) && ensureMapReady(state, false)) {
      state.map.flyTo([Number(shop.latitude), Number(shop.longitude)], Math.max(state.map.getZoom(), 13), {
        animate: true,
        duration: 0.65,
      });
    }

    // Carte plein écran : la ligne du dépôt remonte en tête de liste ; sur
    // téléphone la feuille reste repliée, la ligne arrive dans la partie visible.
    if (state.galerie && state.mapOnly) {
      const sheetCard = state.root.querySelector('[data-shop-handle="' + cssEscape(handle) + '"]');
      const sheetBody = sheetCard && sheetCard.closest('[data-shop-list]');
      // scrollTo sur la liste seule : scrollIntoView ferait aussi défiler
      // l'application (overflow: hidden) qui la contient.
      if (sheetBody) {
        sheetBody.scrollTo({ top: sheetCard.offsetTop - sheetBody.offsetTop, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
      }
      return;
    }

    if (isMobileViewport()) {
      state.collapsed = false;
      animateSheetTo(state, 0, 0);
      updateSheetUI(state);
    }

    const card = state.root.querySelector('[data-shop-handle="' + cssEscape(handle) + '"]');
    if (card && source !== 'marker') {
      card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else if (card && isMobileViewport()) {
      window.setTimeout(function () {
        card.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }, 90);
    }
  }

  function updateCounts(state) {
    const captionNode = state.root.querySelector('[data-results-caption]');
    const chipNode = state.root.querySelector('[data-map-chip]');
    const statusNode = state.root.querySelector('[data-search-status]');
    const activeCity = getScopeCity(state);
    const scopeLabel = activeCity ? activeCity.name : 'Toute la France';

    if (captionNode && state.galerie) {
      captionNode.textContent = state.currentCoords ? 'triés par distance' : 'dans l’ordre de la liste';
    } else if (captionNode) {
      if (state.currentCoords) {
        captionNode.textContent = 'Tri par distance depuis ' + (state.currentAddressLabel || 'votre position');
      } else if (activeCity) {
        captionNode.textContent = 'Adresses autour de ' + activeCity.name;
      } else {
        captionNode.textContent = 'Toutes les adresses disponibles en France';
      }
    }

    if (chipNode && !state.galerie) {
      chipNode.textContent = scopeLabel;
    }

    if (statusNode && !state.currentCoords) {
      statusNode.textContent = '';
    }
  }

  function updatePagination(state) {
    const pagination = state.root.querySelector('[data-pagination]');
    if (!pagination) return;

    const label = pagination.querySelector('[data-pagination-label]');
    const previousButton = pagination.querySelector('[data-pagination-prev]');
    const nextButton = pagination.querySelector('[data-pagination-next]');
    const pageCount = getPageCount(state);
    const enabled = pageCount > 1;

    pagination.hidden = !enabled;

    if (!enabled) return;

    if (label) {
      label.textContent = 'Page ' + state.listPage + ' sur ' + pageCount;
    }

    if (previousButton) {
      previousButton.disabled = state.listPage <= 1;
    }

    if (nextButton) {
      nextButton.disabled = state.listPage >= pageCount;
    }
  }

  function fitMapToCurrentScope(state) {
    if (!state.map || !window.L) return;

    // Hub galerie : la France métropolitaine entière, quelles que soient les villes.
    if (state.galerie && state.config.mode === 'hub') {
      state.map.fitBounds([[42.3, -4.8], [51.1, 8.2]], { animate: false });
      return;
    }

    const activeCity = getScopeCity(state);

    // Galerie : on cadre sur les dépôts, le périmètre de la ville n'est qu'un repère.
    if (!state.galerie && !state.currentCoords && activeCity && state.boundaryLayer && state.boundaryHandle === activeCity.handle) {
      const bounds = state.boundaryLayer.getBounds();
      if (bounds && bounds.isValid()) {
        state.map.fitBounds(bounds.pad(0.08), {
          animate: true,
          paddingTopLeft: [24, 24],
          paddingBottomRight: [24, 24 + getSheetCover(state)],
        });
        return;
      }
    }

    if (!state.currentCoords && state.config.mode === 'city' && activeCity) {
      const fallbackShops = getCityFallbackShops(state, activeCity);
      if (fallbackShops.length) {
        fitMapToShops(state, fallbackShops);
        return;
      }

      if (hasCoordinates(activeCity)) {
        focusCity(state, activeCity.handle);
        return;
      }
    }

    fitMapToVisible(state, state.currentCoords);
  }

  function fitMapToVisible(state, extraCoords) {
    fitMapToShops(state, getMappableShops(state), extraCoords);
  }

  function fitMapToShops(state, shops, extraCoords) {
    if (!state.map || !window.L) return;

    const mappableShops = Array.isArray(shops) ? shops.filter(hasCoordinates) : [];
    const activeCity = getScopeCity(state);

    if (mappableShops.length === 0) {
      if (activeCity && hasCoordinates(activeCity)) {
        state.map.setView([Number(activeCity.latitude), Number(activeCity.longitude)], CITY_FOCUS_ZOOM, { animate: true });
      } else {
        state.map.setView([DEFAULT_CENTER.latitude, DEFAULT_CENTER.longitude], 6, { animate: true });
      }
      return;
    }

    if (mappableShops.length === 1 && !extraCoords) {
      state.map.setView([Number(mappableShops[0].latitude), Number(mappableShops[0].longitude)], 14, {
        animate: true,
      });
      return;
    }

    const bounds = window.L.latLngBounds(
      mappableShops.map(function (shop) {
        return [Number(shop.latitude), Number(shop.longitude)];
      })
    );

    if (extraCoords) {
      bounds.extend([extraCoords.latitude, extraCoords.longitude]);
    }

    state.map.fitBounds(bounds.pad(0.14), {
      animate: true,
      paddingTopLeft: [24, 24],
      paddingBottomRight: [24, 24 + getSheetCover(state)],
    });
  }

  // Hauteur de carte cachée par la feuille basse (carte plein écran, téléphone).
  function getSheetCover(state) {
    const pane = state.sheetElements && state.sheetElements.pane;
    if (!sheetEnabled || !pane || !isMobileViewport()) return 0;
    return Math.max(0, pane.offsetHeight - (Number(state.sheetTranslate) || 0));
  }

  function focusMapOnCoords(state, coords, options) {
    if (!state.map || !window.L || !coords) return;

    const settings = options || {};
    const minimumZoom = Number(settings.minimumZoom) || 13;
    const currentZoom = Number(state.map.getZoom()) || minimumZoom;
    const targetZoom = Math.max(currentZoom, minimumZoom);
    const latLng = window.L.latLng(Number(coords.latitude), Number(coords.longitude));
    const projectedPoint = state.map.project(latLng, targetZoom);
    const verticalOffset = getMapVerticalFocusOffset(state);
    const offsetCenter = state.map.unproject(
      window.L.point(projectedPoint.x, projectedPoint.y + verticalOffset),
      targetZoom
    );

    state.map.flyTo([offsetCenter.lat, offsetCenter.lng], targetZoom, {
      animate: true,
      duration: 0.7,
    });
  }

  function getMapVerticalFocusOffset(state) {
    if (!state.map) return 0;

    const mapHeight = state.map.getSize().y || 0;
    if (mapHeight <= 0) return 0;

    if (isMobileViewport() && getSheetCover(state)) {
      return getSheetCover(state) / 2;
    }

    if (isMobileViewport()) {
      return Math.min(150, mapHeight * 0.2);
    }

    return Math.min(96, mapHeight * 0.14);
  }

  function updateBoundary(state, cityHandle, options) {
    if (!state.map || !window.L) return;

    const settings = options || {};
    const requestId = ++state.boundaryRequestId;

    if (state.boundaryLayer) {
      state.map.removeLayer(state.boundaryLayer);
      state.boundaryLayer = null;
      state.boundaryHandle = '';
    }

    if (!cityHandle) {
      if (settings.fit) {
        fitMapToCurrentScope(state);
      }
      return;
    }

    const city = getCityByHandle(state, cityHandle);
    if (!city) return;
    const boundaryUrl = getBoundaryGeoJsonUrl(city);

    if (!boundaryUrl) {
      state.boundaryHandle = city.handle;
      if (settings.fit) {
        focusCity(state, city.handle);
      }
      return;
    }

    fetch(boundaryUrl)
      .then(function (response) {
        return response.json();
      })
      .then(function (geojson) {
        if (!state.map || !window.L || requestId !== state.boundaryRequestId) return;

        const primaryColor = getCssRgbValue(state.root, '--root-highlight-lable-color', '250, 79, 99');

        state.boundaryLayer = window.L.geoJSON(geojson, {
          style: function () {
            // Galerie : simple filet noir, la ville n'est pas une zone colorée.
            if (state.galerie) {
              return { color: 'rgb(' + getCssRgbValue(state.root, '--noir-rgb', '0, 0, 0') + ')', weight: 1, opacity: 0.5, fillOpacity: 0 };
            }

            return {
              color: 'rgb(' + primaryColor + ')',
              weight: 2,
              opacity: 0.95,
              fillColor: 'rgb(' + primaryColor + ')',
              fillOpacity: 0.08,
            };
          },
        }).addTo(state.map);

        state.boundaryHandle = city.handle;

        if (settings.fit && !state.currentCoords) {
          fitMapToCurrentScope(state);
        }
      })
      .catch(function () {
        state.boundaryHandle = city.handle;

        if (settings.fit) {
          focusCity(state, city.handle);
        }
      });
  }

  function addUserMarker(state, coords) {
    if (!state.map || !window.L) return;

    if (state.userMarker) {
      state.map.removeLayer(state.userMarker);
    }

    const icon = state.galerie ? window.L.divIcon({
      className: '',
      html: '<span class="dv-you"><span>Vous êtes ici</span></span>',
      iconSize: [18, 18],
      iconAnchor: [9, 9],
    }) : window.L.divIcon({
      className: '',
      html:
        '<div class="depot-vente-user-marker">' +
        '<div class="depot-vente-user-pin" aria-hidden="true">' +
        '<svg viewBox="0 0 32 32" fill="none">' +
        '<path d="M16 29C16 29 24 21.6 24 14.5C24 10.0817 20.4183 6.5 16 6.5C11.5817 6.5 8 10.0817 8 14.5C8 21.6 16 29 16 29Z" />' +
        '<circle cx="16" cy="14.5" r="3.5" />' +
        '</svg>' +
        '</div>' +
        '</div>',
      iconSize: [34, 42],
      iconAnchor: [17, 42],
    });

    state.userMarker = window.L.marker([coords.latitude, coords.longitude], {
      icon: icon,
      zIndexOffset: 1000,
    }).addTo(state.map);
  }

  function openDirections(state, shop) {
    const directionsUrl =
      'https://www.google.com/maps/dir/?api=1&destination=' +
      encodeURIComponent(shop.latitude + ',' + shop.longitude);

    const modal = state.root.querySelector('[data-itinerary-modal]');
    if (!modal) {
      window.open(directionsUrl, '_blank', 'noopener');
      return;
    }

    if (state.galerie) {
      // Maquette : l'invitation n'est proposée qu'une fois par visite.
      let alreadySeen = false;
      try {
        alreadySeen = window.sessionStorage.getItem(INVITATION_KEY) === '1';
        window.sessionStorage.setItem(INVITATION_KEY, '1');
      } catch (error) {
        alreadySeen = false;
      }

      if (alreadySeen) {
        window.open(directionsUrl, '_blank', 'noopener');
        return;
      }

      const go = modal.querySelector('[data-modal-secondary]');
      if (go) go.href = directionsUrl;
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      const closeButton = modal.querySelector('[data-modal-close]');
      if (closeButton) closeButton.focus();
      return;
    }

    state.pendingDirectionsUrl = directionsUrl;
    const isParis =
      /paris/i.test(shop.cityName || '') ||
      /paris/i.test(shop.locality || '') ||
      String(shop.postalCode || '').slice(0, 2) === '75';

    const titleNode = modal.querySelector('[data-modal-title]');
    const copyNode = modal.querySelector('[data-modal-copy]');
    const primaryNode = modal.querySelector('[data-modal-primary]');
    const secondaryNode = modal.querySelector('[data-modal-secondary]');

    if (titleNode) {
      titleNode.textContent = 'Avant de vous déplacer';
    }

    if (copyNode) {
      copyNode.textContent = isParis
        ? 'Un coursier Jaiio peut récupérer vos pièces dès demain. Gratuit, simple et sans rendez-vous en boutique.'
        : 'Envoyez vos pièces gratuitement avec une étiquette prépayée Jaiio. Nous gérons ensuite toute la vente.';
    }

    if (primaryNode) {
      primaryNode.textContent = isParis ? 'Faire passer un coursier' : 'Envoyer mes pièces';
      primaryNode.href = '/pages/vendre-ses-vetements';
    }

    if (secondaryNode) {
      secondaryNode.textContent = 'Continuer vers l’itinéraire';
      secondaryNode.href = directionsUrl;
      secondaryNode.target = '_blank';
      secondaryNode.rel = 'noopener';
    }

    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.documentElement.style.overflow = '';
  }

  function buildPopupMarkup(state, shop) {
    const distance = state.currentCoords ? formatDistance(computeDistance(state.currentCoords, shop)) : '';

    if (state.galerie) {
      return (
        '<div class="dv-tip">' +
        '<b>' + escapeHtml(shop.name || '') + '</b>' +
        '<span>' + escapeHtml([distance, shop.address || ''].filter(Boolean).join(' · ')) + '</span>' +
        (state.mapOnly ? '<button type="button" data-popup-itinerary="' + escapeHtml(shop.handle || '') + '">Itinéraire</button>' : '') +
        '</div>'
      );
    }

    const distanceMarkup = distance
      ? '<span class="depot-vente-popup__distance">' + escapeHtml(distance) + '</span>'
      : '';
    const localityLine = [shop.postalCode || '', shop.locality || shop.cityName || ''].filter(Boolean).join(' ');
    const addressLine = [shop.address || '', localityLine].filter(Boolean).join(', ');
    const itineraryMarkup = state.mapOnly
      ? '<button class="depot-vente-popup__cta" type="button" data-popup-itinerary="' + escapeHtml(shop.handle || '') + '">Itineraire</button>'
      : '';

    return (
      '<div class="depot-vente-popup">' +
      '<p class="depot-vente-popup__eyebrow"><span>' + escapeHtml(shop.cityName || '') + '</span>' + distanceMarkup + '</p>' +
      '<strong class="depot-vente-popup__title">' + escapeHtml(shop.name || '') + '</strong>' +
      (addressLine ? '<p class="depot-vente-popup__address">' + escapeHtml(addressLine) + '</p>' : '') +
      itineraryMarkup +
      '</div>'
    );
  }

  function buildShopCardMarkup(state, shop, index) {
    const isActive = shop.handle === state.activeShopHandle;
    const distance = state.currentCoords ? formatDistance(computeDistance(state.currentCoords, shop)) : '';
    const distanceMarkup = distance
      ? '<span class="depot-vente-shop-card__distance" data-distance>' + escapeHtml(distance) + '</span>'
      : '<span class="depot-vente-shop-card__distance" data-distance hidden></span>';

    return (
      '<article class="depot-vente-shop-card' + (isActive ? ' is-active' : '') + '"' +
      ' id="shop-' + escapeHtml(shop.handle || '') + '"' +
      ' data-shop-card' +
      ' data-shop-handle="' + escapeHtml(shop.handle || '') + '"' +
      ' data-city-handle="' + escapeHtml(shop.cityHandle || '') + '"' +
      ' data-shop-name="' + escapeHtml(shop.name || '') + '"' +
      ' data-shop-address="' + escapeHtml(shop.address || '') + '"' +
      ' data-shop-postal-code="' + escapeHtml(shop.postalCode || '') + '"' +
      ' data-shop-locality="' + escapeHtml(shop.locality || '') + '"' +
      ' data-shop-lat="' + escapeHtml(shop.latitude || '') + '"' +
      ' data-shop-lng="' + escapeHtml(shop.longitude || '') + '"' +
      '>' +
      '<div class="depot-vente-shop-card__body">' +
      '<div class="depot-vente-shop-card__meta">' +
      '<div class="depot-vente-shop-card__meta-main">' +
      '<span class="depot-vente-shop-card__index">' + escapeHtml(String(index)) + '</span>' +
      (shop.cityName ? '<span class="depot-vente-shop-card__city">' + escapeHtml(shop.cityName) + '</span>' : '') +
      '</div>' +
      distanceMarkup +
      '</div>' +
      '<h3 class="depot-vente-shop-card__title">' + escapeHtml(shop.name || '') + '</h3>' +
      '<p class="depot-vente-shop-card__address">' +
      escapeHtml(shop.address || '') + '<br>' +
      escapeHtml([shop.postalCode || '', shop.locality || ''].join(' ').trim()) +
      '</p>' +
      '<div class="depot-vente-shop-card__actions">' +
      '<button class="depot-vente-shop-card__button depot-vente-shop-card__button--ghost" type="button" data-map-focus>Voir sur la carte</button>' +
      '<button class="depot-vente-shop-card__button depot-vente-shop-card__button--primary" type="button" data-itinerary>Itinéraire</button>' +
      '</div>' +
      '</div>' +
      '</article>'
    );
  }

  function scrollListToTop(state) {
    const pane = state.sheetElements.pane;
    if (!pane) return;

    pane.scrollTo({
      top: 0,
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
    });
  }

  function syncListPageForShop(state, handle) {
    const shopIndex = state.visibleShops.findIndex(function (shop) {
      return shop.handle === handle;
    });

    if (shopIndex === -1 || !isPaginatedList(state)) return;
    state.listPage = Math.floor(shopIndex / state.listPageSize) + 1;
  }

  function getListShops(state) {
    if (!isPaginatedList(state)) {
      return state.visibleShops;
    }

    const start = getListStartIndex(state);
    return state.visibleShops.slice(start, start + state.listPageSize);
  }

  function getListStartIndex(state) {
    if (!isPaginatedList(state)) return 0;
    return (state.listPage - 1) * state.listPageSize;
  }

  function getPageCount(state) {
    if (!isPaginatedList(state)) return 1;
    return Math.max(1, Math.ceil(state.visibleShops.length / state.listPageSize));
  }

  function clampListPage(state) {
    state.listPage = clamp(state.listPage, 1, getPageCount(state));
  }

  function isPaginatedList(state) {
    return state.visibleShops.length > state.listPageSize;
  }

  function getListPageSize(config) {
    const configuredSize = config.mode === 'city'
      ? Number(config.cityPageSize) || 8
      : Number(config.hubPageSize) || 12;

    if (window.innerWidth <= 699) {
      return config.mode === 'city'
        ? Math.max(4, configuredSize - 2)
        : Math.max(6, configuredSize - 4);
    }

    return configuredSize;
  }

  function getScopeCity(state) {
    if (state.currentCityFilter !== 'all') {
      return getCityByHandle(state, state.currentCityFilter);
    }

    if (state.config.mode === 'city') {
      return getCityByHandle(state, state.config.currentCityHandle);
    }

    return null;
  }

  function scheduleMapResize(state) {
    if (!state.map) return;

    if (state.pendingMapResize) {
      window.cancelAnimationFrame(state.pendingMapResize);
    }

    state.pendingMapResize = window.requestAnimationFrame(function () {
      state.map.invalidateSize();
      state.pendingMapResize = 0;
    });
  }

  function geocodeAddress(query) {
    const endpoint =
      'https://data.geopf.fr/geocodage/search?q=' +
      encodeURIComponent(query) +
      '&index=address&limit=1';

    return fetch(endpoint, {
      headers: {
        Accept: 'application/json',
      },
    })
      .then(ensureSuccessResponse)
      .then(function (response) {
        return response.json();
      })
      .then(function (results) {
        const feature = results && Array.isArray(results.features) ? results.features[0] : null;
        if (!feature || !feature.geometry || !Array.isArray(feature.geometry.coordinates)) {
          throw new Error('No result');
        }

        return {
          latitude: Number(feature.geometry.coordinates[1]),
          longitude: Number(feature.geometry.coordinates[0]),
          label: feature.properties && feature.properties.label ? feature.properties.label : query,
        };
      });
  }

  function fetchAddressSuggestions(query, context, signal) {
    const sanitizedQuery = sanitizeAddressInput(query).trim();
    if (!sanitizedQuery) {
      return Promise.resolve([]);
    }

    return Promise.allSettled([
      fetchCompletionSuggestions(sanitizedQuery, context, signal),
      searchAddressSuggestions(sanitizedQuery, context, signal),
    ]).then(function (results) {
      const combined = [];
      let abortError = null;

      results.forEach(function (result) {
        if (result.status === 'fulfilled' && Array.isArray(result.value)) {
          combined.push.apply(combined, result.value);
          return;
        }

        if (result.reason && result.reason.name === 'AbortError') {
          abortError = result.reason;
        }
      });

      if (abortError) {
        throw abortError;
      }

      combined.push.apply(combined, getLocalAddressSuggestions(sanitizedQuery, context));
      return rankAddressSuggestions(combined, sanitizedQuery, context);
    });
  }

  function fetchCompletionSuggestions(query, context, signal) {
    const territoryHint = getAddressTerritoryHint(query);
    const params = new URLSearchParams({
      text: query,
      maximumResponses: '8',
      terr: territoryHint || 'METROPOLE',
    });

    if (context && context.cityCode) {
      params.set('citycode', context.cityCode);
    }

    if (context && context.currentCoords) {
      params.set('lonlat', context.currentCoords.longitude + ',' + context.currentCoords.latitude);
    }

    return fetch('https://data.geopf.fr/geocodage/completion/?' + params.toString(), {
      headers: {
        Accept: 'application/json',
      },
      signal: signal,
    })
      .then(ensureSuccessResponse)
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        if (!payload || !Array.isArray(payload.results)) {
          return [];
        }

        const suggestions = payload.results.map(function (item) {
          const rawLabel = item.fulltext || '';
          return {
            label: rawLabel,
            displayLabel: '',
            latitude: Number(item.y),
            longitude: Number(item.x),
            postalCode: item.zipcode || '',
            cityCode: item.citycode || '',
            city: item.city || '',
            street: extractSuggestionStreet(rawLabel, item.street || '', item.city || '', item.zipcode || ''),
          };
        }).filter(function (item) {
          return item.label && Number.isFinite(item.latitude) && Number.isFinite(item.longitude);
        });

        return suggestions;
      });
  }

  function searchAddressSuggestions(query, context, signal) {
    const fallbackQuery = buildAddressSearchQuery(query, context);
    const params = new URLSearchParams({
      q: fallbackQuery,
      index: 'address',
      limit: '8',
    });

    return fetch('https://data.geopf.fr/geocodage/search?' + params.toString(), {
      headers: {
        Accept: 'application/json',
      },
      signal: signal,
    })
      .then(ensureSuccessResponse)
      .then(function (response) {
        return response.json();
      })
      .then(function (payload) {
        if (!payload || !Array.isArray(payload.features)) {
          return [];
        }

        const suggestions = payload.features.map(function (feature) {
          const properties = feature && feature.properties ? feature.properties : {};
          const coordinates = feature && feature.geometry && Array.isArray(feature.geometry.coordinates)
            ? feature.geometry.coordinates
            : [];

          return {
            label: properties.label || '',
            displayLabel: '',
            latitude: Number(coordinates[1]),
            longitude: Number(coordinates[0]),
            postalCode: properties.postcode || '',
            cityCode: properties.citycode || '',
            city: properties.city || '',
            street: extractSuggestionStreet(
              properties.label || '',
              properties.name || '',
              properties.city || '',
              properties.postcode || ''
            ),
          };
        }).filter(function (item) {
          return item.label && Number.isFinite(item.latitude) && Number.isFinite(item.longitude);
        });

        return suggestions;
      })
      .catch(function (error) {
        if (error && error.name === 'AbortError') {
          throw error;
        }

        return [];
      });
  }

  function updateAddressSuggestions(state, elements, query, input, status) {
    const dropdown = elements && elements.dropdown;
    const node = elements && elements.list;
    if (!dropdown || !node) return;

    const trimmedQuery = sanitizeAddressInput(query).trim();
    const items = (state.addressSuggestions || []).map(function (suggestion) {
      return {
        type: 'suggestion',
        suggestion: suggestion,
      };
    });

    if (!items.length && trimmedQuery.length >= 2) {
      items.push({
        type: 'manual',
        label: trimmedQuery,
      });
    }

    state.addressSuggestionItems = items;

    if (!items.length) {
      dropdown.hidden = true;
      node.innerHTML = '';
      return;
    }

    if (state.activeSuggestionIndex >= items.length) {
      state.activeSuggestionIndex = items.length - 1;
    }

    node.innerHTML = items.map(function (item, index) {
      if (item.type === 'manual') {
        return '' +
          '<button type="button" class="depot-vente__search-suggestion depot-vente__search-suggestion--manual" data-address-suggestion-index="' + index + '">' +
            '<span class="depot-vente__search-suggestion-title">Rechercher "' + escapeHtml(item.label) + '"</span>' +
            '<span class="depot-vente__search-suggestion-meta">Lancer la recherche avec votre saisie actuelle</span>' +
          '</button>';
      }

      return '' +
        '<button type="button" class="depot-vente__search-suggestion" data-address-suggestion-index="' + index + '">' +
          '<span class="depot-vente__search-suggestion-title">' + escapeHtml(item.suggestion.displayLabel || item.suggestion.label) + '</span>' +
          '<span class="depot-vente__search-suggestion-meta">' + escapeHtml(buildSuggestionMeta(item.suggestion)) + '</span>' +
        '</button>';
    }).join('');

    dropdown.hidden = false;
    syncAddressSuggestionActiveState(node, state.activeSuggestionIndex);

    node.querySelectorAll('[data-address-suggestion-index]').forEach(function (button) {
      button.addEventListener('mouseenter', function () {
        state.activeSuggestionIndex = Number(button.getAttribute('data-address-suggestion-index'));
        syncAddressSuggestionActiveState(node, state.activeSuggestionIndex);
      });

      button.addEventListener('pointerdown', function (event) {
        event.preventDefault();
      });

      button.addEventListener('click', function () {
        const index = Number(button.getAttribute('data-address-suggestion-index'));
        applyAddressSuggestionSelection(state, items[index], input, status, elements);
      });
    });
  }

  function getSuggestionContext(state) {
    const scopedCity = getScopeCity(state);
    return {
      cityCode: scopedCity && scopedCity.inseeCode ? scopedCity.inseeCode : '',
      cityName: scopedCity && scopedCity.name ? scopedCity.name : '',
      currentCoords: state.currentCoords || null,
      localities: state.localitySuggestions || [],
    };
  }

  function findAddressSuggestion(suggestions, query) {
    const normalizedQuery = normalizeText(query);
    return (suggestions || []).find(function (item) {
      return normalizeText(item.displayLabel || item.label) === normalizedQuery ||
        normalizeText(item.label) === normalizedQuery;
    }) || null;
  }

  function getPreferredAddressSuggestion(state) {
    const items = state.addressSuggestionItems || [];
    const activeItem = state.activeSuggestionIndex >= 0 ? items[state.activeSuggestionIndex] : null;

    if (activeItem && activeItem.type === 'suggestion' && activeItem.suggestion) {
      return activeItem.suggestion;
    }

    const firstSuggestion = items.find(function (item) {
      return item.type === 'suggestion' && item.suggestion;
    });

    return firstSuggestion ? firstSuggestion.suggestion : null;
  }

  function normalizeSearchQuery(query, state) {
    const scopedCity = getScopeCity(state);
    if (!scopedCity || !scopedCity.name) return query;
    if (/\b\d{5}\b/.test(query) || normalizeText(query).indexOf(normalizeText(scopedCity.name)) !== -1) {
      return query;
    }

    return query + ' ' + scopedCity.name;
  }

  function buildAddressSearchQuery(query, context) {
    const trimmedQuery = sanitizeAddressInput(query).trim();
    if (!trimmedQuery) return '';

    if (!context || !context.cityName) {
      return trimmedQuery;
    }

    const normalizedQuery = normalizeText(trimmedQuery);
    const normalizedCityName = normalizeText(context.cityName);
    if (normalizedQuery.indexOf(normalizedCityName) !== -1 || /\b\d{5}\b/.test(trimmedQuery)) {
      return trimmedQuery;
    }

    return trimmedQuery + ' ' + context.cityName;
  }

  function rankAddressSuggestions(suggestions, query, context) {
    const postalFragment = getPostalFragment(query);

    return dedupeAddressSuggestions((suggestions || []).slice())
      .map(function (item) {
        item.displayLabel = formatSuggestionDisplayLabel(item, query, postalFragment);
        return item;
      })
      .sort(function (left, right) {
        const scoreDifference = computeSuggestionScore(right, query, postalFragment, context) - computeSuggestionScore(left, query, postalFragment, context);
        if (scoreDifference !== 0) return scoreDifference;

        return String(left.displayLabel || left.label || '').localeCompare(String(right.displayLabel || right.label || ''), 'fr');
      })
      .slice(0, 6);
  }

  function computeSuggestionScore(suggestion, query, postalFragment, context) {
    let score = 0;
    const normalizedQuery = normalizeText(query);
    const queryTokens = getSearchTokens(query);
    const suggestionPostalCode = String(suggestion && suggestion.postalCode ? suggestion.postalCode : '');
    const normalizedLabel = normalizeText(suggestion.displayLabel || suggestion.label);
    const normalizedStreet = normalizeText(suggestion.street);
    const normalizedCity = normalizeText(suggestion.city);

    if (normalizedQuery) {
      if (normalizedLabel.indexOf(normalizedQuery) === 0) {
        score += 140;
      } else if (normalizedLabel.indexOf(normalizedQuery) !== -1) {
        score += 90;
      }
    }

    queryTokens.forEach(function (token) {
      if (token.length < 2) return;

      if (normalizedStreet && normalizedStreet.indexOf(token) !== -1) {
        score += token.length >= 4 ? 26 : 14;
      } else if (normalizedLabel.indexOf(token) !== -1) {
        score += token.length >= 4 ? 12 : 6;
      }

      if (normalizedCity && normalizedCity.indexOf(token) !== -1) {
        score += token.length >= 4 ? 30 : 16;
      }

      if (suggestionPostalCode.indexOf(token) === 0) {
        score += token.length >= 4 ? 44 : 24;
      }
    });

    if (postalFragment) {
      if (suggestionPostalCode.indexOf(postalFragment) === 0) {
        score += 60;
      } else if (postalFragment.length >= 3 && suggestionPostalCode.indexOf(postalFragment.slice(0, 2)) === 0) {
        score += 20;
      }
    }

    if (context && context.cityCode && suggestion.cityCode === context.cityCode) {
      score += 80;
    }

    if (context && context.cityName && normalizeText(suggestion.city) === normalizeText(context.cityName)) {
      score += 20;
    }

    if (context && context.currentCoords) {
      score -= computeDistance(context.currentCoords, suggestion) / 10;
    }

    return score;
  }

  function dedupeAddressSuggestions(suggestions) {
    const seen = new Set();

    return (suggestions || []).filter(function (item) {
      const key = normalizeText(item.label);
      if (!key || seen.has(key)) {
        return false;
      }

      seen.add(key);
      return true;
    });
  }

  function getPostalFragment(query) {
    const matches = sanitizeAddressInput(query).match(/\d{2,5}/g);
    if (!matches || matches.length === 0) return '';

    return matches[matches.length - 1];
  }

  function getAddressTerritoryHint(query) {
    const postalFragment = getPostalFragment(query);
    if (!postalFragment) return '';

    if (postalFragment.length === 5) {
      return postalFragment;
    }

    if (postalFragment.length < 2) {
      return '';
    }

    if ((postalFragment.indexOf('97') === 0 || postalFragment.indexOf('98') === 0) && postalFragment.length >= 3) {
      return postalFragment.slice(0, 3);
    }

    return postalFragment.slice(0, 2);
  }

  function sanitizeAddressInput(value) {
    return String(value || '')
      .replace(/[|;]+/g, ' ')
      .replace(/\s{2,}/g, ' ')
      .trimStart();
  }

  function getSearchTokens(query) {
    return normalizeText(query)
      .split(/\s+/)
      .filter(Boolean);
  }

  function formatSuggestionDisplayLabel(suggestion, query, postalFragment) {
    const street = suggestion.street || extractSuggestionStreet(
      suggestion.label,
      '',
      suggestion.city || '',
      suggestion.postalCode || ''
    );
    const suffixPostalCity = [suggestion.postalCode, suggestion.city].filter(Boolean).join(' ');
    const suffixCityPostal = [suggestion.city, suggestion.postalCode].filter(Boolean).join(' ');
    const normalizedQuery = normalizeText(query);
    const cityInQuery = suggestion.city && normalizedQuery.indexOf(normalizeText(suggestion.city)) !== -1;
    const hasPostalFragment = postalFragment && String(suggestion.postalCode || '').indexOf(postalFragment) === 0;
    const suffix = cityInQuery && !hasPostalFragment ? suffixCityPostal : suffixPostalCity;

    return [street, suffix].filter(Boolean).join(' ').replace(/\s{2,}/g, ' ').trim();
  }

  function extractSuggestionStreet(label, fallbackStreet, city, postalCode) {
    const rawLabel = String(label || '').trim();
    if (!rawLabel) return '';

    const streetCandidate = String(fallbackStreet || '').trim();
    const normalizedCity = normalizeText(city);

    if (normalizedCity) {
      const normalizedLabelWithoutPostalCode = normalizeText(rawLabel.replace(String(postalCode || ''), ' '))
        .replace(/\s+/g, ' ')
        .trim();
      const labelMatchesCityOnly = normalizedLabelWithoutPostalCode === normalizedCity ||
        normalizedLabelWithoutPostalCode === (normalizedCity + ' ' + normalizedCity).trim();

      if (labelMatchesCityOnly && (!streetCandidate || normalizeText(streetCandidate) === normalizedCity)) {
        return '';
      }
    }

    if (streetCandidate) {
      return streetCandidate;
    }

    if (rawLabel.indexOf(',') !== -1) {
      return rawLabel.split(',')[0].trim();
    }

    return rawLabel.replace(/\s+\d{5}\s+.+$/, '').trim();
  }

  function buildLocalitySuggestions(config) {
    const citiesByHandle = new Map();
    const suggestions = [];
    const seen = new Set();

    (config && Array.isArray(config.cities) ? config.cities : []).forEach(function (city) {
      citiesByHandle.set(city.handle, city);
    });

    (config && Array.isArray(config.shops) ? config.shops : []).forEach(function (shop) {
      const postalCode = String(shop && shop.postalCode ? shop.postalCode : '').trim();
      const cityName = String(shop && (shop.locality || shop.cityName) ? (shop.locality || shop.cityName) : '').trim();
      const cityMeta = citiesByHandle.get(shop.cityHandle);
      const latitude = cityMeta && Number.isFinite(Number(cityMeta.latitude)) ? Number(cityMeta.latitude) : Number(shop.latitude);
      const longitude = cityMeta && Number.isFinite(Number(cityMeta.longitude)) ? Number(cityMeta.longitude) : Number(shop.longitude);
      const cityCode = cityMeta && cityMeta.inseeCode ? cityMeta.inseeCode : '';

      if ((!cityName && !postalCode) || !Number.isFinite(latitude) || !Number.isFinite(longitude)) {
        return;
      }

      const key = normalizeText([postalCode, cityName].join(' '));
      if (!key || seen.has(key)) {
        return;
      }

      seen.add(key);
      suggestions.push({
        label: [postalCode, cityName].filter(Boolean).join(' ').trim(),
        displayLabel: '',
        latitude: latitude,
        longitude: longitude,
        postalCode: postalCode,
        cityCode: cityCode,
        city: cityName,
        street: '',
      });
    });

    return suggestions;
  }

  function getLocalAddressSuggestions(query, context) {
    const localities = context && Array.isArray(context.localities) ? context.localities : [];
    if (!localities.length) {
      return [];
    }

    return localities
      .map(function (item) {
        return {
          suggestion: item,
          score: computeLocalSuggestionMatchScore(item, query),
        };
      })
      .filter(function (entry) {
        return entry.score > 0;
      })
      .sort(function (left, right) {
        return right.score - left.score;
      })
      .slice(0, 6)
      .map(function (entry) {
        return entry.suggestion;
      });
  }

  function computeLocalSuggestionMatchScore(suggestion, query) {
    const normalizedQuery = normalizeText(query);
    const tokens = getSearchTokens(query);
    const haystack = normalizeText([
      suggestion.label,
      suggestion.city,
      suggestion.postalCode,
    ].join(' '));
    let score = 0;

    if (normalizedQuery && haystack.indexOf(normalizedQuery) !== -1) {
      score += 80;
    }

    tokens.forEach(function (token) {
      if (token.length < 2) return;
      if (normalizeText(suggestion.city).indexOf(token) !== -1) {
        score += token.length >= 4 ? 28 : 14;
      }

      if (String(suggestion.postalCode || '').indexOf(token) === 0) {
        score += token.length >= 4 ? 36 : 18;
      }

      if (haystack.indexOf(token) !== -1) {
        score += 8;
      }
    });

    return score;
  }

  function buildSuggestionMeta(suggestion) {
    const parts = [];

    if (suggestion.street) {
      parts.push('Adresse');
    } else if (suggestion.city || suggestion.postalCode) {
      parts.push('Ville ou code postal');
    }

    if (suggestion.city || suggestion.postalCode) {
      parts.push([suggestion.postalCode, suggestion.city].filter(Boolean).join(' '));
    }

    return parts.filter(Boolean).join(' · ');
  }

  function syncAddressSuggestionActiveState(node, activeIndex) {
    if (!node) return;

    node.querySelectorAll('[data-address-suggestion-index]').forEach(function (button) {
      const index = Number(button.getAttribute('data-address-suggestion-index'));
      const isActive = index === activeIndex;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function applyAddressSuggestionSelection(state, item, input, status, elements) {
    if (!item) return;

    if (item.type === 'manual') {
      input.value = item.label;
      performAddressSearch(state, input, status, elements, item.label);
      return;
    }

    input.value = item.suggestion.displayLabel || item.suggestion.label;
    performAddressSearch(state, input, status, elements, input.value, item.suggestion);
  }

  function performAddressSearch(state, input, status, elements, forcedQuery, forcedSuggestion) {
    const sanitizedValue = sanitizeAddressInput(forcedQuery || input.value);
    if (sanitizedValue !== input.value) {
      input.value = sanitizedValue;
    }

    const query = sanitizedValue.trim();
    if (!query) return;

    const selectedSuggestion = forcedSuggestion ||
      findAddressSuggestion(state.addressSuggestions, query) ||
      getPreferredAddressSuggestion(state);
    cancelSuggestionLookup(state);

    state.addressSuggestions = [];
    state.addressSuggestionItems = [];
    state.activeSuggestionIndex = -1;
    updateAddressSuggestions(state, elements, '', input, status);

    setStatus(status, 'Recherche de l’adresse...');
    const pendingLookup = selectedSuggestion
      ? Promise.resolve(selectedSuggestion)
      : geocodeAddress(normalizeSearchQuery(query, state));

    pendingLookup
      .then(function (coords) {
        const label = selectedSuggestion
          ? (selectedSuggestion.displayLabel || selectedSuggestion.label)
          : (coords.label || query);
        input.value = label;

        // Hub : une ville choisie dans la liste mène à sa page.
        if (state.galerie && state.config.mode === 'hub' && selectedSuggestion && !selectedSuggestion.street) {
          const city = findCityByName(state, selectedSuggestion.city);
          if (city && city.url) {
            window.location.href = city.url;
            return;
          }
        }

        applyOrigin(state, { latitude: Number(coords.latitude), longitude: Number(coords.longitude) }, label, status);
      })
      .catch(function () {
        setStatus(status, 'Adresse introuvable. Essaie une adresse plus précise.');
      });
  }

  // Point de départ choisi (adresse ou position). Sur le hub galerie, on
  // l'emmène vers la carte de la ville du dépôt le plus proche ; ailleurs,
  // la liste se trie par distance.
  function applyOrigin(state, coords, label, status) {
    if (state.galerie && state.config.mode === 'hub') {
      const nearest = state.config.shops.filter(hasCoordinates).sort(function (left, right) {
        return computeDistance(coords, left) - computeDistance(coords, right);
      })[0];
      const city = nearest ? getCityByHandle(state, nearest.cityHandle) : null;

      if (!city || !city.url) {
        setStatus(status, 'Aucun dépôt-vente répertorié près de cette adresse.');
        return;
      }

      try {
        window.sessionStorage.setItem(ORIGIN_KEY, JSON.stringify({
          latitude: coords.latitude,
          longitude: coords.longitude,
          label: label,
        }));
      } catch (error) {
        // Sans sessionStorage, la carte s'ouvre sans tri : rien de bloquant.
      }

      window.location.href = city.url + '?view=carte';
      return;
    }

    if (!ensureMapReady(state, false)) {
      setStatus(status, 'La carte ne peut pas être chargée pour le moment.');
      return;
    }

    state.currentCoords = coords;
    state.currentAddressLabel = label;
    addUserMarker(state, coords);
    updateVisibleShops(state, { resetPage: true, fitMap: false });
    focusMapOnCoords(state, coords, { minimumZoom: state.config.mode === 'city' ? 13 : 12.5 });
    setStatus(status, label === 'votre position' ? 'Position trouvée · tri par distance' : 'Adresse localisée · tri par distance');
  }

  function findCityByName(state, name) {
    const wanted = normalizeText(name || '');
    return (state.config.cities || []).find(function (city) {
      return normalizeText(city.name) === wanted;
    }) || null;
  }

  function ensureSuccessResponse(response) {
    if (!response || !response.ok) {
      throw new Error('Request failed');
    }

    return response;
  }

  function computeDistance(origin, shop) {
    if (!origin || !shop) return Number.MAX_SAFE_INTEGER;

    const lat1 = toRadians(origin.latitude);
    const lon1 = toRadians(origin.longitude);
    const lat2 = toRadians(Number(shop.latitude));
    const lon2 = toRadians(Number(shop.longitude));
    const dLat = lat2 - lat1;
    const dLon = lon2 - lon1;
    const a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return 6371 * c;
  }

  function formatDistance(distanceKm) {
    if (!Number.isFinite(distanceKm)) return '';
    if (distanceKm < 1) return Math.round(distanceKm * 1000) + ' m';
    return distanceKm.toFixed(distanceKm >= 10 ? 0 : 1).replace('.', ',') + ' km';
  }

  function getCityByHandle(state, handle) {
    return state.config.cities.find(function (city) {
      return city.handle === handle;
    });
  }

  function findShop(state, handle) {
    return state.config.shops.find(function (shop) {
      return shop.handle === handle;
    });
  }

  function getMappableShops(state) {
    return state.visibleShops.filter(hasCoordinates);
  }

  function getBoundaryGeoJsonUrl(city) {
    if (!city) return '';

    if (city.boundaryUrl) {
      return city.boundaryUrl;
    }

    if (city.inseeCode) {
      return (
        'https://geo.api.gouv.fr/communes/' +
        encodeURIComponent(String(city.inseeCode)) +
        '?fields=nom,code,centre,contour&format=geojson&geometry=contour'
      );
    }

    return '';
  }

  function getCityFallbackShops(state, city) {
    const shops = getMappableShops(state);
    if (!city || !hasCoordinates(city) || shops.length <= 1) {
      return shops;
    }

    const cityCoords = {
      latitude: Number(city.latitude),
      longitude: Number(city.longitude),
    };

    const shopsByDistance = shops
      .map(function (shop) {
        return {
          shop: shop,
          distance: computeDistance(cityCoords, shop),
        };
      })
      .sort(function (left, right) {
        return left.distance - right.distance;
      });

    const nearbyShops = shopsByDistance
      .filter(function (entry) {
        return entry.distance <= 35000;
      })
      .map(function (entry) {
        return entry.shop;
      });

    if (nearbyShops.length >= Math.max(3, Math.ceil(shops.length * 0.6))) {
      return nearbyShops;
    }

    return shopsByDistance
      .slice(0, Math.max(1, Math.ceil(shops.length * 0.9)))
      .map(function (entry) {
        return entry.shop;
      });
  }

  function setStatus(node, message) {
    if (node) {
      node.textContent = message;
    }
  }

  function pushDragHistory(history, y) {
    history.push({
      time: Date.now(),
      y: y,
    });

    while (history.length > 6) {
      history.shift();
    }
  }

  function computeDragVelocity(history) {
    if (!history || history.length < 2) return 0;

    const latest = history[history.length - 1];
    let earliest = history[0];

    for (let index = history.length - 2; index >= 0; index -= 1) {
      if (latest.time - history[index].time > 90) {
        earliest = history[index];
        break;
      }
      earliest = history[index];
    }

    const deltaTime = latest.time - earliest.time;
    if (deltaTime <= 0) return 0;
    return ((latest.y - earliest.y) / deltaTime) * 1000;
  }

  function project(initialVelocity, decelerationRate) {
    return (initialVelocity / 1000) * decelerationRate / (1 - decelerationRate);
  }

  function rubberband(overshoot, dimension, constant) {
    const factor = constant || 0.55;
    return (overshoot * dimension * factor) / (dimension + factor * Math.abs(overshoot));
  }

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isMobileViewport() {
    return window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  function toRadians(value) {
    return (Number(value) * Math.PI) / 180;
  }

  function cssEscape(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/"/g, '\\"');
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function normalizeText(value) {
    return String(value || '')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim()
      .toLowerCase();
  }

  function hasCoordinates(item) {
    return Number.isFinite(Number(item && item.latitude)) && Number.isFinite(Number(item && item.longitude));
  }

  function usesInlineMobileList() {
    return !sheetEnabled && window.innerWidth <= MOBILE_BREAKPOINT;
  }

  function focusCity(state, cityHandle) {
    const city = getCityByHandle(state, cityHandle);
    if (!city || !state.map || !hasCoordinates(city)) return;

    state.map.setView([Number(city.latitude), Number(city.longitude)], CITY_FOCUS_ZOOM, {
      animate: true,
    });
  }

  function getCssRgbValue(element, variableName, fallback) {
    const value = window.getComputedStyle(element).getPropertyValue(variableName).trim();
    return value || fallback;
  }
})();
